export const activateActionTypes = {

    //activateLandingPage - getActivationStatus
    GET_ACTIVATE_STATUS_REQUEST: 'GET_ACTIVATE_STATUS_REQUEST',
    GET_ACTIVATE_STATUS_SUCCESS: 'GET_ACTIVATE_STATUS_SUCCESS',
    GET_ACTIVATE_STATUS_FAILED: 'GET_ACTIVATE_STATUS_FAILED',
    GET_ACTIVATE_STATUS_404: 'GET_ACTIVATE_STATUS_404',

    //activateLandingPage - sendActivationEmail
    SEND_ACTIVATION_EMAIL_REQUEST: 'SEND_ACTIVATION_EMAIL_REQUEST',
    SEND_ACTIVATION_EMAIL_SUCCESS: 'SEND_ACTIVATION_EMAIL_SUCCESS',
    SEND_ACTIVATION_EMAIL_FAILED: 'SEND_ACTIVATION_EMAIL_FAILED',

};


// WEBPACK FOOTER //
// ./src/activate/actions/activate-action-types.js